<template>
  <Layout>
    <div v-if="model" class="fruit-detail-wrapper">
      <!-- Thanh điều hướng quay lại danh sách -->
      <div class="back-navigation-bar">
        <div class="container">
          <button type="button" class="btn-back-nav" @click="goBack">
            <span class="back-icon-circle">
              <span class="isax isax-arrow-left icon-back"></span>
            </span>
            <span class="back-text-label">{{ $t('detail.back_to_list') || 'Quay lại danh sách' }}</span>
          </button>
        </div>
      </div>

      <!-- Hero Header Section -->
      <section class="hero-section">
        <div class="hero-container">
          <!-- Cột trái: Thông tin tên, diện tích, sản lượng -->
          <div class="hero-info">
            <div class="hero-header-row">
              <div class="hero-header-left">
                <div class="badges-row" v-if="activeCertifications && activeCertifications.length > 0">
                  <div v-for="(cn, idx) in activeCertifications" :key="idx" class="category-badge">
                    <img v-if="cn.files && cn.files.length > 0 && (cn.files[0].fileId || cn.files[0].path)"
                      :src="getImageUrl(cn.files[0])" class="icon-badge-img" />
                    <span v-else class="isax isax-verify icon-badge"></span>
                    {{ getLangValueFromItem(cn, 'key') }}
                  </div>
                </div>
                <div v-else class="category-badge">
                  <span class="isax isax-verify icon-badge"></span>
                  {{ $t('detail.specialty_category') || 'Danh mục trái cây đặc sản' }}
                </div>

                <h1 class="fruit-name">
                  {{ getLangValueFromItem(model, 'name') }} <br />
                  <span v-if="model.tenKhoaHoc || tenKhoaHocFallback" class="scientific-name">
                    <i>({{ model.tenKhoaHoc || tenKhoaHocFallback }})</i>
                  </span>
                </h1>
              </div>
              <div class="hero-header-right" v-if="model.qrCode2 && (model.qrCode2.path || model.qrCode2.fileId)">
                <img :src="apiView + model.qrCode2.fileId" alt="QR Code" class="hero-qr-img" />
                <div class="qr-views-count">
                  <span class="isax isax-eye icon-view"></span>
                  <span class="view-text">{{ model.view || 0 }} {{ $t('catalog.views') || 'Lượt xem ' }}</span>
                </div>
              </div>
            </div>

            <div class="fruit-brief"
              v-html="getLangValueFromItem(model, 'moTa') || getLangValueFromItem(model, 'dacTinhSinhHoc')"></div>

            <div class="stats-row">
              <div class="stat-card">
                <span class="isax isax-box icon-stat text-primary"></span>
                <div class="stat-meta">
                  <span class="stat-label">{{ $t('detail.area') || 'Diện tích' }}</span>
                  <span class="stat-value">{{ dicitichVal }}</span>
                </div>
              </div>
              <div class="stat-card">
                <span class="isax isax-bar-graph-1 icon-stat text-primary"></span>
                <div class="stat-meta">
                  <span class="stat-label">{{ $t('detail.yield') || 'Sản lượng' }}</span>
                  <span class="stat-value">{{ sanluongVal }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Cột phải: Khung ảnh đại diện tỷ lệ 1:1 cao cấp -->
          <div class="hero-media-wrapper">
            <div class="media-accent-bg"></div>
            <img v-if="model.avatar && (model.avatar.fileId || model.avatar.path)" :src="getImageUrl(model.avatar)"
              :alt="getLangValueFromItem(model, 'name')" class="main-image shadow-effect clickable"
              @click="showImg(0, [model.avatar])" />
            <div v-else class="media-placeholder shadow-effect">
              <span class="isax isax-image placeholder-icon"></span>
              <p>{{ $t('detail.updating_images') || 'Đang cập nhật hình ảnh' }}</p>
            </div>
          </div>
        </div>
      </section>

      <!-- Main Content Area: Asymmetric Layout 12 cột -->
      <section class="detail-container">
        <div class="grid-layout">

          <!-- BÊN TRÁI: QR CODE CHÍNH HÃNG, ĐẶC TÍNH, THƯ VIỆN & THUỘC TÍNH CÂN ĐỐI (5 cột) -->
          <aside class="sidebar-area">



            <!-- 2. Hộp thông số đặc tính sinh học -->
            <div class="specs-card">
              <h3 class="sidebar-card-title">
                <span class="isax isax-info-circle"></span>
                {{ $t('detail.bio_characteristics') }}
              </h3>
              <div class="specs-list">
                <div class="spec-item" v-if="getLangValueFromItem(model, 'dacTinhSinhHoc')">
                  <p class="spec-subtitle">{{ $t('detail.bio_characteristics') || 'Đặc tính sinh học' }}</p>
                  <div class="spec-desc" v-html="getLangValueFromItem(model, 'dacTinhSinhHoc')"></div>
                </div>
                <div class="spec-item" v-if="getLangValueFromItem(model, 'ghiChu')">
                  <p class="spec-subtitle">{{ $t('detail.cert_protection') || 'Chứng nhận & Bảo hộ' }}</p>
                  <p class="spec-desc whitespace-pre-wrap">{{ getLangValueFromItem(model, 'ghiChu') }}</p>
                </div>
              </div>
            </div>

            <!-- 3. Hộp vùng trồng tập trung -->
            <div class="vung-trong-card mb-4" v-if="getLangValueFromItem(model, 'vungTrongTapTrung')">
              <h3 class="sidebar-card-title text-heading">
                {{ $t('detail.concentrated_area') || 'Vùng trồng tập trung' }}
              </h3>
              <p class="vung-trong-desc">
                {{ getLangValueFromItem(model, 'vungTrongTapTrung') }}
              </p>
            </div>

            <!-- 4. THUỘC TÍNH ĐỘNG DÀN ĐỀU CỘT TRÁI (leftAttributes) -->
            <div v-if="leftAttributes.length > 0" class="left-attributes-wrapper mt-4">
              <div v-for="(group, gIdx) in leftAttributes" :key="'left-group-' + gIdx"
                class="attribute-group-section mb-4">
                <h3 class="group-category-title">{{ getLangValueFromItem(group, 'key') }}</h3>

                <!-- Nếu là nhóm xuất khẩu: hiển thị dạng Quốc kỳ rực rỡ đặc trưng -->
                <div class="attributes-grid">
                  <div v-for="(val, vIdx) in group.Value" :key="vIdx"
                    :class="['attr-card-item', val.files && val.files.length > 0 ? 'has-images' : '']">
                    <div class="attr-text-content">
                      <h4 class="attr-item-title">{{ getLangValueFromItem(val, 'name') }}</h4>
                      <p class="attr-item-value" v-if="getLangValueFromItem(val, 'value')">
                        {{ getLangValueFromItem(val, 'value') }}
                      </p>
                    </div>
                    <div class="attr-images-gallery" v-if="val.files && val.files.length > 0">
                      <img v-for="(img, i) in val.files" :key="i" :src="getImageUrl(img)" @click="showImg(i, val.files)"
                        alt="Attribute attachment" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 5. Tài liệu, Báo cáo đính kèm -->
            <div class="docs-download-card" v-if="model.fileGhiChu && model.fileGhiChu.length > 0">
              <h3 class="sidebar-card-title">
                <span class="isax isax-folder-open"></span> {{ $t('detail.attached_documents') || 'Tài liệu đính kèm' }}
              </h3>
              <div class="docs-list">
                <a v-for="(doc, dIdx) in model.fileGhiChu" :key="dIdx" :href="getImageUrl(doc)" target="_blank"
                  class="doc-download-item">
                  <span class="isax isax-document-text text-danger me-2"></span>
                  <span class="doc-name">{{ doc.fileName }}</span>
                </a>
              </div>
            </div>
          </aside>

          <!-- BÊN PHẢI: ALBUM ẢNH, GIỐNG TIÊU BIỂU, THỊ TRƯỜNG XUẤT KHẨU & THUỘC TÍNH CÂN ĐỐI (7 cột) -->
          <article class="article-area">

            <!-- 1. Album ảnh thực tế tại vườn (Đưa lên đầu cột phải tạo điểm nhấn sống động) -->
            <div class="gallery-section-wrapper mb-5" v-if="model.files && model.files.length > 0">
              <h3 class="gallery-title">{{ $t('detail.orchard_photos') || 'Hình ảnh thực tế tại vườn' }}</h3>
              <div class="photo-grid-layout">
                <div v-for="(file, index) in model.files" :key="index"
                  :class="['photo-item', index === 0 ? 'photo-large' : '']" @click="showImg(index, model.files)">
                  <img :src="getImageUrl(file)" class="gallery-img" alt="Orchard details" />
                </div>
              </div>
            </div>

            <!-- 3. THUỘC TÍNH ĐỘNG DÀN ĐỀU CỘT PHẢI (rightAttributes) -->
            <div v-if="rightAttributes.length > 0" class="right-other-attributes-wrapper">
              <div v-for="(group, gIdx) in rightAttributes" :key="'right-group-' + gIdx"
                class="attribute-group-section mb-5">
                <h3 class="group-category-title">{{ getLangValueFromItem(group, 'key') }}</h3>

                <!-- Nếu là nhóm xuất khẩu: hiển thị dạng Quốc kỳ rực rỡ đặc trưng -->


                <div class="attributes-grid">
                  <div v-for="(val, vIdx) in group.Value" :key="vIdx"
                    :class="['attr-card-item', val.files && val.files.length > 0 ? 'has-images' : '']">
                    <div class="attr-text-content">
                      <h4 class="attr-item-title">{{ getLangValueFromItem(val, 'name') }}</h4>
                      <p class="attr-item-value" v-if="getLangValueFromItem(val, 'value')">
                        {{ getLangValueFromItem(val, 'value') }}
                      </p>
                    </div>
                    <div class="attr-images-gallery" v-if="val.files && val.files.length > 0">
                      <img v-for="(img, i) in val.files" :key="i" :src="getImageUrl(img)" @click="showImg(i, val.files)"
                        alt="Attribute image" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </article>
        </div>
      </section>

      <!-- Infographics Section -->
      <section v-if="currentInfographic" class="infographic-section">
        <div class="infographic-header text-center">
          <h3 class="infographic-title text-heading">
            {{ $t('detail.infographic_title') || 'Thông tin đồ họa nông sản' }}
          </h3>
          <p class="infographic-subtitle-text text-muted">
            {{ $t('detail.infographic_subtitle') }}
          </p>
        </div>
        <div class="infographic-container" @click="showImg(0, [currentInfographic])">
          <img :src="getImageUrl(currentInfographic)" :alt="getLangValueFromItem(model, 'name')"
            class="infographic-image" />
          <div class="infographic-overlay">
            <span class="isax isax-search-zoom-in icon-zoom"></span>
            <p class="overlay-zoom-text">{{ $t('detail.click_to_zoom') || 'Click để phóng to ảnh' }}</p>
          </div>
        </div>
      </section>

      <!-- Associated Businesses Section -->
      <section v-if="doanhNghieps && doanhNghieps.length > 0" class="business-section">
        <div class="business-header text-center">
          <h3 class="business-title text-heading">
            {{ $t('detail.associated_businesses') || 'Doanh nghiệp liên kết' }}
          </h3>
          <p class="business-subtitle-text text-muted">
            {{ $t('detail.associated_businesses_subtitle') || 'Danh sách doanh nghiệp phân phối và cung cấp sản phẩm' }}
          </p>
        </div>
        <div class="business-grid-visit">
          <div v-for="dn in doanhNghieps" :key="dn._id" class="business-card-visit-wrapper">
            <business-card-visit :doanh-nghiep="dn" />
          </div>
        </div>
      </section>
    </div>

    <!-- Lightbox phóng to ảnh -->
    <vue-easy-lightbox :visible="lightboxVisible" :imgs="lightboxImages" :index="lightboxIndex"
      @hide="lightboxVisible = false"></vue-easy-lightbox>
  </Layout>
</template>

<script>
import Layout from "@/layouts/layout.vue";
import VueEasyLightbox from "vue-easy-lightbox";
import { traiCayModel } from "@/models/profession/traiCay/traiCayModel";
import BusinessCardVisit from "@/components/widgets/businessCardVisit.vue";

export default {
  name: "FruitDetail",
  components: {
    Layout,
    VueEasyLightbox,
    BusinessCardVisit,
  },
  props: {
    // Nhận dữ liệu traiCayModel động truyền vào từ danh sách ngoài
    fruitData: {
      type: Object,
      required: false,
      default: () => null,
    },
  },
  data() {
    return {
      traiCay: traiCayModel.baseJson(),
      tenKhoaHocFallback: "Durio zibethinus L.",
      currentPage: 1,
      perPage: 9,
      lightboxVisible: false,
      lightboxImages: [],
      lightboxIndex: 0,
      apiView: process.env.VUE_APP_API_URL + 'filesminio/view/',
      doanhNghieps: [],
    };
  },
  computed: {
    model() {
      const raw = this.fruitData || this.traiCay;
      if (!raw) return null;
      return traiCayModel.fromJson(raw);
    },
    activeCertifications() {
      if (!this.model || !Array.isArray(this.model.chungNhan)) return [];
      return this.model.chungNhan.filter(cn => cn.isBool === true);
    },
    // Sắp xếp các nhóm thuộc tính động theo thứ tự (index)
    sortedThuocTinhs() {
      if (!this.model || !this.model.thuocTinhs) return [];
      return [...this.model.thuocTinhs].sort((a, b) => (a.index || 0) - (b.index || 0));
    },
    // Trích xuất số liệu diện tích động bóc tách từ helper
    dicitichVal() {
      if (!this.model) return this.$t('detail.updating') || "Đang cập nhật";
      const val = this.getLangValueFromItem(this.model, 'dienTichSanLuong');
      const [area] = this.splitDienTichSanLuong(val);
      return area;
    },
    // Trích xuất số liệu sản lượng động bóc tách từ helper
    sanluongVal() {
      if (!this.model) return this.$t('detail.updating') || "Đang cập nhật";
      const val = this.getLangValueFromItem(this.model, 'dienTichSanLuong');
      const [, yieldVal] = this.splitDienTichSanLuong(val);
      return yieldVal;
    },

    // 🌐 QUY ƯỚC CỘT TRÁI (Sidebar): Những thuộc tính thường có index < 5 (Ví dụ: 0, 1, 2, 3, 4)
    leftAttributes() {
      if (!this.sortedThuocTinhs) return [];
      return this.sortedThuocTinhs.filter(group => (group.index || 0) < 5);
    },

    // 🌐 QUY ƯỚC CỘT PHẢI (Nội dung chính): Những thuộc tính thường có index >= 5 (Ví dụ: 5, 6, 7, 8...)
    rightAttributes() {
      if (!this.sortedThuocTinhs) return [];
      return this.sortedThuocTinhs.filter(group => (group.index || 0) >= 5);
    },


    currentInfographic() {
      if (!this.model || !this.model.infographics || !Array.isArray(this.model.infographics) || this.model.infographics.length === 0) {
        return null;
      }
      const currentLocale = this.$i18n ? this.$i18n.locale : "vi";
      if (currentLocale === "en") {
        const enInfo = this.model.infographics[1];
        if (enInfo && (enInfo.fileId || enInfo.path)) {
          return enInfo;
        }
      }
      const viInfo = this.model.infographics[0];
      if (viInfo && (viInfo.fileId || viInfo.path)) {
        return viInfo;
      }
      return null;
    },
  },
  filters: {
    // Bộ lọc thu gọn nội dung tóm tắt
    truncate(text, length) {
      if (!text) return "";
      if (text.length <= length) return text;
      return text.substring(0, length) + "...";
    },
  },
  watch: {
    "model.code": {
      immediate: true,
      handler(newCode) {
        if (newCode) {
          this.fetchDoanhNghieps(newCode);
        }
      }
    }
  },
  created() {
    window.addEventListener("scroll", this.windowScroll);
    if (!this.fruitData && this.$route.params.code) {
      this.getChiTietTraiCay();
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.windowScroll);
  },
  methods: {

    splitDienTichSanLuong(val) {
      const fallback = this.$t('detail.updating') || "Đang cập nhật";
      if (!val) return [fallback, fallback];

      // 1. Phân tách theo ký tự xuống dòng \n (Đáp ứng JSON mới dạng Xoài Cát Chu)
      if (val.includes('\n')) {
        const parts = val.split('\n');
        return [
          parts[0] ? parts[0].trim() : fallback,
          parts[1] ? parts[1].trim() : fallback
        ];
      }

      // 2. Phân tách theo ký tự gạch chéo / (Đáp ứng định dạng cũ)
      if (val.includes('/')) {
        const parts = val.split('/');
        return [
          parts[0] ? parts[0].trim() : fallback,
          parts[1] ? parts[1].trim() : fallback
        ];
      }

      // 3. Sử dụng Regex thông minh bóc tách nếu chuỗi viết liền kề (Ví dụ: "tỉnh 224.300")
      const match = val.match(/(.+?\s)(?=\b\d+[\d.,]*\s+[a-zA-ZÀ-ỹ])/);
      if (match && match[1]) {
        const first = match[1].trim();
        const second = val.substring(match[1].length).trim();
        return [first, second];
      }

      return [val, fallback];
    },
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        const query = {};
        if (this.$route.query.embed) query.embed = this.$route.query.embed;
        if (this.$route.query.iframe) query.iframe = this.$route.query.iframe;
        this.$router.push({ path: '/trai-cay/danh-sach', query });
      }
    },
    getLangValue(fieldName) {
      const currentLocale = this.$i18n ? this.$i18n.locale : "vi";
      return currentLocale === "en" ? `${fieldName}En` : fieldName;
    },
    getLangValueFromItem(item, fieldName) {
      if (!item) return "";
      const currentLocale = this.$i18n ? this.$i18n.locale : "vi";
      if (currentLocale === "en") {
        const enField = `${fieldName}En`;
        return item[enField] || item[fieldName] || "";
      }
      return item[fieldName] || "";
    },
    async getChiTietTraiCay() {
      try {
        await this.$store
          .dispatch("profession/traiCay/traiCayStore/getByCode", this.$route.params.code)
          .then((res) => {
            if (res && res.data) {
              this.traiCay = traiCayModel.fromJson(res.data);
            }
          });

        console.info('Mã QR trái cây link: ', this.apiView + this.traiCay?.qrCode2.fileId)
      } catch (err) {
        console.error("Lỗi khi fetch chi tiết sản phẩm:", err);
      }
    },

    showImg(index, files) {
      if (!files || files.length === 0) return;
      this.lightboxImages = files.map((file) => this.getImageUrl(file));
      this.lightboxIndex = index;
      this.lightboxVisible = true;
    },
    getImageUrl(file) {
      if (!file) return "";
      if (file.fileId) {
        return `${process.env.VUE_APP_API_URL}filesminio/view/${file.fileId}`;
      }
      return file.path || "";
    },
    windowScroll() {
      const navbar = document.getElementById("navbar");
      if (navbar) {
        if (
          document.body.scrollTop >= 50 ||
          document.documentElement.scrollTop >= 50
        ) {
          navbar.classList.add("nav-sticky");
        } else {
          navbar.classList.remove("nav-sticky");
        }
      }
    },
    async fetchDoanhNghieps(codeTC) {
      try {
        const dataParam = {
          code: codeTC,

        };
        await this.$store.dispatch("profession/doanhNghiep/doanhNghiepStore/getDoanhNghiepByCodeTC", dataParam).then(res => {
          if (res && res.data) {
            this.doanhNghieps = res.data;
          }
        });
      } catch (err) {
        console.error("Lỗi khi fetch danh sách doanh nghiệp:", err);
      }
    },
  },
};
</script>

<style scoped>
/* ======================== CHỦ ĐỀ MÀU SẮC & PHÔNG CHỮ CHUNG ======================== */
.fruit-detail-wrapper {
  font-family: var(--font-body-standard), sans-serif;
  color: var(--on-surface, #181d17);
  background-color: var(--background, #f7fbf0);
  line-height: 1.6;
}

/* ======================== REDESIGNED BACK NAVIGATION ======================== */
.back-navigation-bar {
  padding: 1rem 0 0 0;
  background-color: rgba(27, 94, 32, 0.05);
  text-align: left;
}

@media (max-width: 576px) {
  .back-navigation-bar {
    padding: 0.6rem 0 0 0;
  }
}

.btn-back-nav {
  display: inline-flex;
  align-items: center;
  gap: 0.85rem;
  background: #ffffff;
  border: 1px solid var(--outline-variant, #bfcaba);
  padding: 0.57rem 1.14rem 0.57rem 0.85rem;
  border-radius: 714.28rem;
  color: var(--color-public-primary, #2e7d32);
  font-family: var(--font-heading-admin), sans-serif;
  font-weight: 700;
  font-size: 0.92rem;
  cursor: pointer;
  outline: none;
  box-shadow: 0 0.14rem 0.57rem rgba(0, 0, 0, 0.04);
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

@media (max-width: 576px) {
  .btn-back-nav {
    padding: 0.43rem 0.85rem 0.43rem 0.57rem;
    font-size: 0.85rem;
    gap: 0.57rem;
  }
}

.back-icon-circle {
  width: 2rem;
  height: 2rem;
  background-color: rgba(46, 125, 50, 0.08);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

@media (max-width: 576px) {
  .back-icon-circle {
    width: 1.71rem;
    height: 1.71rem;
  }
}

.icon-back {
  font-size: 1rem;
  transition: transform 0.2s ease;
}

@media (max-width: 576px) {
  .icon-back {
    font-size: 0.85rem;
  }
}

.back-text-label {
  letter-spacing: 0.02em;
}

.btn-back-nav:hover {
  background-color: var(--color-public-primary, #2e7d32);
  color: #ffffff;
  border-color: var(--color-public-primary, #2e7d32);
  box-shadow: 0 0.28rem 0.85rem rgba(46, 125, 50, 0.15);
  transform: translateX(-0.28rem);
}

.btn-back-nav:hover .back-icon-circle {
  background-color: rgba(255, 255, 255, 0.2);
}

.btn-back-nav:hover .icon-back {
  transform: translateX(-0.14rem);
}


/* ======================== HERO SECTION (HEADER BANNER) ======================== */
.hero-section {
  background: linear-gradient(180deg,
      rgba(27, 94, 32, 0.05) 0%,
      rgba(27, 94, 32, 0) 100%);
  padding: 0.8rem 1.14rem 1.2rem 1.14rem;
}

@media (min-width: 768px) {
  .hero-section {
    padding: 1rem 1.71rem 1.5rem 1.71rem;
  }
}

.hero-container {
  max-width: var(--container-max, 1280px);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  align-items: start;
}

@media (min-width: 992px) {
  .hero-container {
    flex-direction: row;
    padding: 0.8rem 2.85rem;
    gap: 2.28rem;
  }
}

.hero-info {
  flex: 1;
  text-align: left;
}

.hero-header-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 1.71rem;
  gap: 1.14rem;
}

.hero-header-left {
  flex: 8;
}

.hero-header-right {
  flex: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.qr-views-count {
  display: flex;
  align-items: center;
  gap: 6px;
  background-color: var(--surface-container, #ebefe5);
  padding: 6px 12px;
  border-radius: 20px;
  border: 1px solid var(--outline-variant, #bfcaba);
  font-size: 0.9rem;
  color: var(--outline, #707a6c);
}

.qr-views-count .icon-view {
  font-size: 1.1rem;
  color: var(--primary, #0d631b);
}

.qr-views-count .view-text {
  font-weight: 600;
  font-family: var(--font-body-standard), sans-serif;
}

.hero-qr-img {
  width: 150px;
  height: 150px;
  object-fit: contain;
  background: #ffffff;
  padding: 0.28rem;
  border-radius: 0.57rem;
  border: 1px solid var(--outline-variant, #bfcaba);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
}

/* Badge Danh mục */
.badges-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.71rem;
  margin-bottom: 1.71rem;
}

.badges-row .category-badge {
  margin-bottom: 0;
}

.category-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.57rem;
  padding: 0.43rem 1.14rem;
  background-color: #a3f69c;
  color: #002204;
  border-radius: 714.28rem;
  font-size: 0.85rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 1.71rem;
}

.icon-badge-img {
  width: 1.2rem;
  height: 1.2rem;
  object-fit: contain;
  border-radius: 4px;
}

.icon-badge {
  font-size: 1.14rem;
}

/* Tên Trái cây và Tên Khoa học */
.fruit-name {
  font-family: var(--font-heading-organic), sans-serif;
  font-size: 2rem;
  color: var(--text-heading, #1b5e20);
  font-weight: 800;
  line-height: 1.25;
  margin-bottom: 1.14rem;
}

@media (min-width: 768px) {
  .fruit-name {
    font-size: 3.42rem;
  }
}

.scientific-name {
  font-family: var(--font-body-standard), sans-serif;
  font-size: 1.2rem;
  color: var(--secondary, #8f4e00);
  font-weight: 600;
  font-style: italic !important;
}

@media (min-width: 768px) {
  .scientific-name {
    font-size: 1.71rem;
  }
}

.fruit-brief {
  font-size: 1rem;
  color: var(--on-surface-variant, #40493d);
  max-width: 45.71rem;
  margin-bottom: 2.28rem;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

@media (min-width: 768px) {
  .fruit-brief {
    font-size: 1.14rem;
  }
}

/* Thống kê nhanh */
.stats-row {
  display: flex;
  flex-wrap: wrap;
  gap: 1.14rem;
}

.stat-card {
  display: flex;
  align-items: center;
  gap: 1.14rem;
  background-color: var(--surface-container, #ebefe5);
  padding: 1.14rem;
  border-radius: 0.85rem;
  border: 1px solid var(--outline-variant, #bfcaba);
  flex: 1 1 calc(50% - 0.57rem);
  min-width: 10rem;
}

.icon-stat {
  font-size: 2rem;
  color: var(--primary, #0d631b);
}

.stat-meta {
  display: flex;
  flex-direction: column;
}

.stat-label {
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--on-surface-variant, #40493d);
}

.stat-value {
  font-family: var(--font-heading-organic), sans-serif;
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--primary, #0d631b);
}

@media (min-width: 768px) {
  .stat-value {
    font-size: 1.42rem;
  }
}

/* Khung Ảnh đại diện bên phải */
.hero-media-wrapper {
  position: relative;
  width: 100%;
  max-width: 28rem;
  align-self: center;
  margin-top: 1.5rem;
}

@media (min-width: 992px) {
  .hero-media-wrapper {
    width: 40%;
    margin-top: 0;
  }
}

.media-accent-bg {
  position: absolute;
  inset: -1.14rem;
  background-color: rgba(13, 99, 27, 0.08);
  border-radius: 2.28rem;
  filter: blur(1.14rem);
}

.main-image {
  position: relative;
  width: 100%;
  max-width: 100%;
  aspect-ratio: 1 / 1;
  /* 1:1 Ratio theo yêu cầu */
  object-fit: cover;
  border-radius: 2.28rem;
  transition: transform 0.5s ease;
}

.main-image:hover {
  transform: scale(1.01);
}

.media-placeholder {
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  /* 1:1 Ratio */
  background-color: var(--surface-container-high, #e5eadf);
  border: 2px dashed var(--outline-variant, #bfcaba);
  border-radius: 2.28rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: var(--on-surface-variant, #40493d);
  font-weight: 600;
}

.placeholder-icon {
  font-size: 3.42rem;
  margin-bottom: 0.57rem;
}

.shadow-effect {
  box-shadow: 0 1.42rem 1.78rem -0.35rem rgba(0, 0, 0, 0.1), 0 0.71rem 0.71rem -0.35rem rgba(0, 0, 0, 0.04);
}

.clickable {
  cursor: pointer;
}

/* ======================== BỐ CỤC ASYMMETRIC CHÍNH ======================== */
.detail-container {
  max-width: var(--container-max, 1280px);
  margin: 1rem auto 0 auto;
  padding: 0 1.14rem;
}

@media (min-width: 768px) {
  .detail-container {
    margin-top: 2rem;
    padding: 0 1.71rem;
  }
}

@media (min-width: 992px) {
  .detail-container {
    margin-top: 2.5rem;
    padding: 0 2.85rem;
  }
}

.grid-layout {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 1.71rem;
}

@media (min-width: 992px) {
  .grid-layout {
    gap: 2.85rem;
  }
}

/* CỘT SIDEBAR TRÁI (5 CỘT) */
.sidebar-area {
  grid-column: span 12;
  text-align: left;
}

@media (min-width: 992px) {
  .sidebar-area {
    grid-column: span 5;
  }
}

/* HỘP MÃ QR ĐƯỢC LÀM TO & ĐƯA LÊN TRÊN CÙNG */
.qr-large-card {
  background-color: #ffffff;
  border-radius: 1.71rem;
  border: 1px solid var(--outline-variant, #bfcaba);
  padding: 2rem 1.5rem;
  margin-bottom: 1.71rem;
  text-align: center;
}

.qr-large-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 1.42rem;
  border-bottom: 1px solid rgba(187, 202, 186, 0.2);
  padding-bottom: 12px;
}

.icon-qr-header {
  font-size: 24px;
  color: var(--primary, #0d631b);
}

.qr-large-title {
  font-family: var(--font-heading-organic), sans-serif;
  font-size: 1.2rem;
  color: var(--text-heading, #1b5e20);
  font-weight: 800;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.qr-large-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.14rem;
}

.qr-large-image-wrapper {
  width: 13.5rem;
  /* Mã QR rất to, dễ dàng quét */
  height: 13.5rem;
  border: 1px solid var(--outline-variant, #bfcaba);
  border-radius: 12px;
  padding: 10px;
  background-color: #ffffff;
  box-shadow: 0 8px 24px rgba(13, 99, 27, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
}

.qr-large-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.qr-main-label {
  font-family: var(--font-heading-organic), sans-serif;
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--text-heading, #1b5e20);
  margin: 0 0 8px 0;
}

.qr-large-badge {
  display: inline-block;
  font-family: monospace;
  font-size: 0.85rem;
  font-weight: bold;
  background-color: rgba(143, 78, 0, 0.1);
  color: var(--secondary, #8f4e00);
  padding: 4px 12px;
  border-radius: 8px;
  margin-bottom: 12px;
}

.qr-large-tip {
  font-family: var(--font-body-standard), sans-serif;
  font-size: 0.78rem;
  color: var(--on-surface-variant, #40493d);
  line-height: 1.5;
  margin: 0;
}

.specs-card {
  background-color: var(--surface-cream, #fff8e1);
  padding: 1.42rem;
  border-radius: 1.14rem;
  border: 1px solid rgba(187, 202, 186, 0.3);
  margin-bottom: 1.71rem;
}

@media (min-width: 768px) {
  .specs-card {
    padding: 2.28rem;
    border-radius: 1.71rem;
    margin-bottom: 2.28rem;
  }
}

.sidebar-card-title {
  font-family: var(--font-heading-organic), sans-serif;
  font-size: 1.2rem;
  color: var(--text-heading, #1b5e20);
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 0.57rem;
  margin-bottom: 1.71rem;
}

@media (min-width: 768px) {
  .sidebar-card-title {
    font-size: 1.42rem;
  }
}

.specs-list {
  display: flex;
  flex-direction: column;
  gap: 1.14rem;
}

.spec-item {
  padding-bottom: 1.14rem;
  border-bottom: 1px solid var(--outline-variant, #bfcaba);
}

.spec-item:last-child {
  border-bottom: none;
}

.spec-subtitle {
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--secondary, #8f4e00);
  margin-bottom: 0.28rem;
}

.spec-desc {
  font-size: 1rem;
  color: var(--on-surface-variant, #40493d);
  margin: 0;
}

.whitespace-pre-wrap {
  white-space: pre-wrap;
}

/* Hộp vùng trồng tập trung */
.vung-trong-card {
  background-color: var(--surface-container-high, #e5eadf);
  padding: 1.42rem;
  border-radius: 1.14rem;
}

@media (min-width: 768px) {
  .vung-trong-card {
    padding: 2.28rem;
    border-radius: 1.71rem;
  }
}

.vung-trong-desc {
  font-size: 1rem;
  color: var(--on-surface-variant, #40493d);
  line-height: 1.6;
  margin: 0;
}

/* Tài liệu đính kèm */
.docs-download-card {
  background-color: #ffffff;
  padding: 1.42rem;
  border-radius: 1.14rem;
  border: 1px solid rgba(187, 202, 186, 0.3);
  margin-top: 1.71rem;
}

.docs-list {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.doc-download-item {
  display: flex;
  align-items: center;
  padding: 0.85rem 1.14rem;
  background-color: var(--surface-container-low, #f1f5eb);
  border: 1px solid var(--outline-variant, #bfcaba);
  border-radius: 0.85rem;
  text-decoration: none;
  color: var(--on-surface, #1c1d1a);
  transition: all 0.3s ease;
}

.doc-download-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border-color: var(--primary, #0d631b);
  color: var(--primary, #0d631b);
}

.doc-name {
  font-family: var(--font-body-standard), sans-serif;
  font-size: 0.92rem;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* CỘT NỘI DUNG CHÍNH BÊN PHẢI (7 CỘT) */
.article-area {
  grid-column: span 12;
  text-align: left;
}

@media (min-width: 992px) {
  .article-area {
    grid-column: span 7;
  }
}

/* Album ảnh thực tế tại vườn (Chuyển hẳn sang cột phải nhằm tăng chiều cao cột phải, lấp đầy khoảng trắng trống) */
.gallery-section-wrapper {
  margin-bottom: 2.28rem;
}

.gallery-title {
  font-family: var(--font-heading-organic), sans-serif;
  font-size: 1.2rem;
  color: var(--text-heading, #1b5e20);
  font-weight: 700;
  margin-bottom: 1.71rem;
}

@media (min-width: 768px) {
  .gallery-title {
    font-size: 1.42rem;
  }
}

/* Photo Grid Layout: Bento-style */
.photo-grid-layout {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.14rem;
}

@media (min-width: 576px) {
  .photo-grid-layout {
    grid-template-columns: repeat(3, 1fr);
  }
}

.photo-item {
  position: relative;
  aspect-ratio: 1;
  border-radius: 1.14rem;
  overflow: hidden;
  cursor: pointer;
}

.photo-large {
  grid-column: span 2;
  aspect-ratio: 1.79;
}

.gallery-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.photo-item:hover .gallery-img {
  transform: scale(1.08);
}

/* ======================== BỐ CỤC LƯỚI QUỐC KỲ (THỊ TRƯỜNG XUẤT KHẨU) & THUỘC TÍNH ĐỘNG ======================== */
.attribute-group-section {
  text-align: left;
}

.group-category-title {
  font-family: var(--font-heading-organic), sans-serif;
  font-size: 1.2rem;
  color: var(--text-heading, #1b5e20);
  font-weight: 700;
  margin-bottom: 1.42rem;
  position: relative;
  padding-bottom: 0.57rem;
  border-bottom: 1px solid var(--outline-variant, #bfcaba);
}

@media (min-width: 768px) {
  .group-category-title {
    font-size: 1.42rem;
  }
}

.group-category-title::after {
  content: "";
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 3.5rem;
  height: 3px;
  background-color: var(--primary, #0d631b);
  border-radius: 2px;
}

.attributes-grid {
  display: grid;
  grid-template-columns: 1fr !important;
  gap: 1.14rem;
}

.attr-card-item {
  background-color: #ffffff;
  border: 1px solid rgba(187, 202, 186, 0.3);
  border-radius: 1.14rem;
  padding: 1.14rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1.14rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.02);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.attr-card-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);
}

@media (min-width: 768px) {
  .attr-card-item.has-images {
    grid-column: span 2;
    flex-direction: row;
    align-items: center;
  }
}

.attr-text-content {
  flex: 1;
  text-align: left;
}

.attr-item-title {
  font-family: var(--font-heading-organic), sans-serif;
  font-size: 1.07rem;
  color: var(--secondary, #8f4e00);
  font-weight: 700;
  margin: 0 0 0.43rem 0;
}

.attr-item-value {
  font-family: var(--font-body-standard), sans-serif;
  font-size: 0.95rem;
  color: var(--on-surface-variant, #40493d);
  line-height: 1.5;
  margin: 0;
  white-space: pre-wrap;
}

.attr-images-gallery {
  display: flex;
  flex-wrap: wrap;
  gap: 0.57rem;
  flex-shrink: 0;
}

@media (min-width: 768px) {
  .attr-images-gallery {
    max-width: 50%;
  }
}

.attr-images-gallery img {
  width: 4.85rem;
  height: 4.85rem;
  object-fit: cover;
  border-radius: 0.57rem;
  cursor: pointer;
  border: 1px solid var(--outline-variant, #bfcaba);
  transition: transform 0.2s;
}

.attr-images-gallery img:hover {
  transform: scale(1.05);
}

/* ======================== BỐ CỤC LƯỚI QUỐC KỲ (THỊ TRƯỜNG XUẤT KHẨU) ======================== */
.markets-flex-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.market-badge-item {
  background-color: #ffffff;
  border: 1px solid var(--outline-variant, #bfcaba);
  border-radius: 12px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  transition: all 0.2s ease;
  min-width: 150px;
  flex-grow: 1;
  max-width: calc(33.33% - 11px);
}

@media (max-width: 768px) {
  .market-badge-item {
    max-width: 100%;
  }
}

.market-badge-item:hover {
  border-color: var(--primary, #0d631b);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(13, 99, 27, 0.05);
}

.market-flag-wrapper {
  width: 44px;
  height: 30px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.08);
  flex-shrink: 0;
  cursor: pointer;
}

.market-flag-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.market-badge-text {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.market-country-name {
  font-family: var(--font-heading-organic), sans-serif;
  font-size: 13px;
  font-weight: 700;
  color: var(--text-heading, #1b5e20);
}

.market-country-desc {
  font-size: 12px;
  margin: 2px 0 0 0;
  color: var(--on-surface-variant, #40493d);
}

/* ======================== INFOGRAPHIC SECTION ======================== */
.infographic-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 1.5rem;
  padding: 0.8rem 10px 1.5rem 10px;
}

.infographic-header {
  margin-bottom: 2rem;
  max-width: 50rem;
}

.infographic-title {
  font-family: var(--font-heading-organic), sans-serif;
  font-size: 1.3rem;
  color: var(--text-heading, #1b5e20);
  font-weight: 700;
}

@media (min-width: 768px) {
  .infographic-title {
    font-size: 1.71rem;
  }
}

.infographic-subtitle-text {
  font-size: 0.9rem;
  margin-top: 0.5rem;
}

@media (min-width: 768px) {
  .infographic-subtitle-text {
    font-size: 1rem;
  }
}

.infographic-container {
  max-width: 720px;
  width: 100%;
  aspect-ratio: 720 / 960;
  border-radius: 1.14rem;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  border: 1px solid var(--outline-variant, #bfcaba);
  background-color: var(--surface-container, #ebefe5);
  cursor: pointer;
  position: relative;
}

.infographic-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: transform 0.5s ease;
}

.infographic-container:hover .infographic-image {
  transform: scale(1.02);
}

.infographic-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.infographic-container:hover .infographic-overlay {
  opacity: 1;
}

.icon-zoom {
  font-size: 2.5rem;
  color: #ffffff;
  margin-bottom: 0.5rem;
}

.overlay-zoom-text {
  color: #ffffff;
  font-family: var(--font-heading-organic), sans-serif;
  font-weight: 700;
  font-size: 1rem;
  margin: 0;
}

/* ======================== ASSOCIATED BUSINESSES SECTION ======================== */
.business-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 1.5rem;
  padding: 0.8rem 10px 1.5rem 10px;
}

.business-header {
  margin-bottom: 2rem;
  max-width: 50rem;
}

.business-title {
  font-family: var(--font-heading-organic), sans-serif;
  font-size: 1.3rem;
  color: var(--text-heading, #1b5e20);
  font-weight: 700;
}

@media (min-width: 768px) {
  .business-title {
    font-size: 1.71rem;
  }
}

.business-subtitle-text {
  font-size: 0.9rem;
  margin-top: 0.5rem;
}

@media (min-width: 768px) {
  .business-subtitle-text {
    font-size: 1rem;
  }
}

.business-grid-visit {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(450px, 1fr));
  gap: 1.5rem;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  justify-content: center;
}

@media (max-width: 576px) {
  .business-grid-visit {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
}
</style>